import { createFileRoute } from "@tanstack/react-router";
import Leaderboard from "../components/dashboard/leaderboard";
import UpdateModal from "../components/dashboard/new-update-modal";
import SportsActivityCard from "../components/dashboard/sport-activity";
import { WelcomeSection } from "../components/dashboard/welcome-section";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../components/ui/tabs";
import { useRecentActivities } from "../data/activities/hooks";
import { Activity } from "../data/activities/types";

export const Route = createFileRoute("/home")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data: activities, isLoading: isLoadingActivities } =
    useRecentActivities();

  return (
    <div className="flex flex-col gap-2 p-4 bg-gradient-to-br from-[#2b7fff]/10 to-[#fe9a00]/10 w-full h-full">
      <UpdateModal />

      {/* Show welcome section only on desktop */}
      <div className="hidden lg:block">
        <WelcomeSection />
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:flex gap-6 h-[70vh]">
        {/* Recent Activities - 2/3 width */}
        <div className="w-2/3 flex flex-col mt-2 h-full">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-2xl font-bold text-center bg-gradient-to-r from-[#2b7fff] to-[#fe9a00] bg-clip-text text-transparent">
              Recent Activities
            </h2>
          </div>
          <div className="space-y-4 overflow-y-auto flex-1 pr-2">
            {isLoadingActivities ? (
              <div className="text-center py-8 text-gray-500">
                Loading activities...
              </div>
            ) : activities && activities.length > 0 ? (
              activities.map((activity: Activity) => (
                <SportsActivityCard key={activity.id} activity={activity} />
              ))
            ) : (
              <div className="text-center py-8 text-gray-500">
                No recent activities found. Start tracking your workouts!
              </div>
            )}
          </div>
        </div>

        {/* Leaderboards - 1/3 width */}
        <div className="w-1/3 h-full mt-2">
          <Leaderboard />
        </div>
      </div>

      {/* Mobile Layout with Tabs */}
      <div className="lg:hidden mt-2 h-full w-full">
        <Tabs defaultValue="activities" className="w-full h-full">
          <TabsList className="grid w-full grid-cols-3 mb-2 bg-gray-200">
            <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
            <TabsTrigger value="activities">Activities</TabsTrigger>
            <TabsTrigger value="leaderboards">Leaderboards</TabsTrigger>
          </TabsList>
          <TabsContent value="dashboard">
            <WelcomeSection />
          </TabsContent>
          <TabsContent value="activities">
            <div className="flex-1 overflow-auto space-y-4">
              {isLoadingActivities ? (
                <div className="text-center py-8 text-gray-500">
                  Loading activities...
                </div>
              ) : activities && activities.length > 0 ? (
                activities.map((activity: Activity) => (
                  <SportsActivityCard key={activity.id} activity={activity} />
                ))
              ) : (
                <div className="text-center py-8 text-gray-500">
                  No recent activities found. Start tracking your workouts!
                </div>
              )}
            </div>
          </TabsContent>
          <TabsContent value="leaderboards">
            <div className="h-full w-full">
              <Leaderboard />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
